import React, { useCallback, useMemo, useRef } from "react"
import slice from "lodash/slice"

import Pagination from "../pagination/pagination"
import PaginationDynamic from "../paginationDynamic/paginationDynamic"
import Categories from "../categories/categories"
import ItemsList from "../itemsList/itemsList"
import Section from "../section/section"
import isEmpty from "lodash/isEmpty"

import * as styles from "./listingPageContent.module.scss"

const articlesPerPage = 9

const ListingPageContent = props => {
  const {
    blogSearchKeys,
    dynamicPage,
    title,
    subtitle,
    items,
    currentPage,
    totalPages,
    categories,
    baseUrl,
    categorySlug,
    renderItems,
    background,
    entity,
    onSearchKeySelect,
    selectedBySearchKeyData,
    setDynamicPage,
    selectPlaceholder,
  } = props

  const scrollRef = useRef(null)

  const totalDynamicPages = Math.ceil(selectedBySearchKeyData?.length / articlesPerPage)
  const startIndex = (dynamicPage - 1) * articlesPerPage
  const endIndex = startIndex + articlesPerPage

  const renderContent = useMemo(() => {
    if (!items.nodes.length && isEmpty(selectedBySearchKeyData))
      return <div className={styles.noItems}>No items found</div>
    if (renderItems) return renderItems(items)

    const itemsListData = !isEmpty(selectedBySearchKeyData)
      ? slice(selectedBySearchKeyData, startIndex, endIndex)
      : items.nodes

    return <ItemsList entity={entity} items={itemsListData} base={baseUrl} />
  }, [baseUrl, entity, items, renderItems, selectedBySearchKeyData, startIndex, endIndex])

  const getBackgroundColor = isBody => {
    if (background) return background
    if (isBody) return "grey-gradient"
    return "grey"
  }

  const scrollToTarget = useCallback(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      })
    }
  }, [scrollRef])

  const handlePageChange = useCallback(
    newPage => {
      setDynamicPage(newPage)
      scrollToTarget()
    },
    [scrollToTarget, setDynamicPage]
  )

  const handleOnPrevClick = useCallback(() => {
    setDynamicPage(page => page - 1)
    scrollToTarget()
  }, [scrollToTarget, setDynamicPage])

  const handleOnNextClick = useCallback(() => {
    setDynamicPage(page => page + 1)
    scrollToTarget()
  }, [scrollToTarget, setDynamicPage])

  return (
    <>
      <Section className={styles.header}>
        <h1 className="text-align-center">{title}</h1>
        <div className="body2 text-align-center darkgrey my-s" ref={scrollRef}>
          {subtitle}
        </div>
      </Section>
      <Section className={styles.categories} background={getBackgroundColor()}>
        <Categories
          selectPlaceholder={selectPlaceholder}
          blogSearchKeys={blogSearchKeys}
          categories={categories}
          link={baseUrl}
          onSearchKeySelect={onSearchKeySelect}
        />
      </Section>
      <Section background={getBackgroundColor(true)}>{renderContent}</Section>
      <Section>
        {totalPages > 1 && isEmpty(selectedBySearchKeyData) ? (
          <Pagination
            base={categorySlug ? `${baseUrl}/${categorySlug}` : baseUrl}
            currentPage={currentPage}
            totalPages={totalPages}
          />
        ) : totalPages > 1 && !isEmpty(selectedBySearchKeyData) && selectedBySearchKeyData.length > articlesPerPage ? (
          <PaginationDynamic
            onPageClick={handlePageChange}
            onClickNext={handleOnNextClick}
            onClickPrev={handleOnPrevClick}
            currentPage={dynamicPage}
            totalPages={totalDynamicPages}
          />
        ) : null}
      </Section>
    </>
  )
}

export default ListingPageContent
